import * as angular from 'angular';
import {IQService} from "angular";
import {MessagesAlertsService} from "./messages-alerts.service";
import {MessagesRequestsService} from "./messages-requests.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {SmsNotificationType} from "../enums/sms-notification.type";


export class MessagesService {

  constructor(private $q: IQService, private bringozLoaderService: BringozLoaderService, private $log, private messagesRequestsService: MessagesRequestsService, private messagesAlertsService: MessagesAlertsService) {
  }

  getMessagesTotals(from: string, to: string, isSent: boolean | undefined, notificationType: SmsNotificationType) {
    const deferred = this.$q.defer();
    this.bringozLoaderService.on();
    this.messagesRequestsService.getTotals(from, to, isSent, notificationType)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.messagesAlertsService.getTotalsError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }


}

angular
  .module('bringoz.admin.messages')
  .service('messagesService', MessagesService);

